import { useState } from "react";
import { addUsager } from "../api/api";


export default function UsagerForm({ onAdd }) {
    const [form, setForm] = useState({ nom: "", prenom: "", email: "" });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newUsager = await addUsager(form);
        onAdd(newUsager);
        setForm({ nom: "", prenom: "", telephone: "" });
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-2">
            <input name="nom" value={form.nom} onChange={handleChange} placeholder="Nom" required />
            <input name="prenom" value={form.prenom} onChange={handleChange} placeholder="Prénom" required />
            <input name="telephone" type="tel" value={form.telephone} onChange={handleChange} placeholder="telephone" required />
            <button type="submit">Ajouter Usager</button>
        </form>
    );
}
